<div *ngIf="content" [innerHtml]="content | safeHtml"></div>
<div *ngIf="coverages">
  <div class="info-container" *ngFor="let coverage of coverages">
    <mat-icon [svgIcon]="coverage.icono"></mat-icon>
    <p [innerHTML]="coverage.descripcion | safeHtml"></p>
  </div>
</div>
